import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id D3339724-6ECB-4328-83C8-7E956C0271C0
 * name terraform
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/terraform.svg
 * tags
 * - Brand / Logo 
 */
export const TerraformIcon = createSvgIcon(<><path d="M21 5.4V11.8L15.4 15V8.7L21 5.4M14.8 8.7V15L9.2 11.8V5.4L14.8 8.7M14.8 15.7V22.1L9.2 18.9V12.5L14.8 15.7M8.6 5.1V11.5L3 8.3V1.9L8.6 5.1Z" /></>, 'TerraformIcon');
export default TerraformIcon